import { R, Segments } from "apparatus/library/common";
import { Group, Path } from "paper";
export class Swab {
    render(appearance) {
        const { length } = appearance;
        const stickWidth = 4;
        const tipWidth = 9;
        const tipHeight = 26;
        // Stick
        const stick = new Path.Rectangle(R(-stickWidth / 2, 0, stickWidth, length - tipHeight + 6), 1.0).withStroke("thin")
            .withFill("#d8af7fff"); // Light wood
        // Cotton tip - thicker at the bottom, thin at the top
        const tip = new Path(Segments([[tipWidth / 2, -tipHeight], [0, -5], [0, 3]], [[stickWidth / 2 + 1, 0], [0, 0], [0, 0]])).mirrorX()
            .close()
            .withStroke("thin", "#888888")
            .withFill("#eeeeee");
        const graphic = new Group([stick, tip]);
        return {
            graphic: graphic,
            hitShape: graphic.bounds.expand(15).toShape(),
        };
    }
}
Swab.properties = {
    label: "Swab",
    flippable: true,
    defaultAppearance: {
        length: 160,
    },
    appearanceSpecs: [
        {
            spec: "slider", key: "length", label: "Length",
            min: 80, max: 240, step: 5, unit: "mm"
        },
    ],
};
